import React from 'react';
import { capitalize } from 'lodash';
import DataFormattingConfig from './DataFormattingConfig';
import AxisFormattingConfig from './AxisFormattingConfig';
import { getSortOptionsForType } from '../util';
import {
  Checkbox,
  Controls,
  Header,
  LabeledControl,
  Section,
  Text,
  Selection,
  InlineControl,
  TextFormat,
  SubHeader,
} from '../../reporting/sidebar/components';
import { useReportConfiguration } from 'components/reporting/sidebar/ConfiguredReport';

function AxisConfig({
  axis,
  active = false,
  children = null,
  showSort = false,
  sortType,
}) {
  const { get } = useReportConfiguration();
  const chartType = get('chartType');

  return (
    <Section>
      <Header>
        {capitalize(axis)} axis{' '}
        <span style={{ color: 'var(--aha-gray-500)' }}>
          ({axis === 'horizontal' ? 'X' : 'Y'})
        </span>
      </Header>

      <SubHeader>Title</SubHeader>
      <Controls>
        <InlineControl>
          <TextFormat
            configurationKey={`${axis}AxisTitleFormat`}
            defaultSize={14}
            defaultColor='black'
            defaultFontWeight='normal'
            defaultFontStyle='normal'
          />
        </InlineControl>

        <InlineControl>
          <Text configurationKey={[`${axis}Axis`, 'title']} size='large' />
        </InlineControl>

        <LabeledControl title='On'>
          <Checkbox configurationKey={[`${axis}Axis`, 'enabled']} />
        </LabeledControl>
      </Controls>
      {showSort && (
        <>
          <SubHeader>Sort Options</SubHeader>
          <Controls>
            <Selection
              options={getSortOptionsForType(sortType, chartType)}
              configurationKey={`${axis}AxisSort`}
              singleColumn
            />
          </Controls>
        </>
      )}
      <SubHeader>Axis labels</SubHeader>
      <Controls>
        <InlineControl>
          <TextFormat
            configurationKey={`${axis}AxisLabelFormat`}
            defaultSize={12}
            defaultColor='black'
            defaultFontWeight='normal'
            defaultFontStyle='normal'
          />
        </InlineControl>
        <LabeledControl title='Label slant'>
          <Selection
            options={[
              ['0°', 0],
              ['30°', 30],
              ['60°', 60],
              ['90°', 90],
            ]}
            configurationKey={[`${axis}Axis`, 'labelSlant']}
          />
        </LabeledControl>

        {active && (
          <LabeledControl title='Scale'>
            <Selection
              configurationKey='scale'
              options={[
                ['0.01', 0.01],
                ['0.1', 0.1],
                ['Default', 1],
                ['10', 10],
                ['100', 100],
                ['1,000', 1000],
                ['1,000,000', 1000000],
                ['1,000,000,000', 1000000000],
                ['1,000,000,000,000', 1000000000000],
              ]}
            />
          </LabeledControl>
        )}
      </Controls>

      <AxisFormattingConfig axis={axis} active={active} />
      {active && <DataFormattingConfig axis={axis} />}

      {children}
    </Section>
  );
}
export default AxisConfig;
